<p
  ><b>{{ shifts.length }} Shifts selected</b></p
>

<div class="container no-gutters">
  <div class="row">
    <div class="col">
      <button
        mat-button
        color="warn"
        (click)="delete()"
        matTooltip="Shortcut: (Del)"
        >Delete</button
      >
      <button mat-raised-button color="primary" (click)="mergeShifts()"
        >Merge Shifts</button
      >
    </div>
  </div>
</div>
